import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children?: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  scrollTo?: string;
}
export function CTAButton({
  children = 'QUIERO ACCESO INMEDIATO',
  className = '',
  fullWidth = false,
  scrollTo
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (scrollTo) {
      e.preventDefault();
      const element = document.getElementById(scrollTo);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  if (scrollTo) {
    return <button onClick={handleClick} className={`
          group relative inline-flex items-center justify-center
          bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400
          text-white font-bold text-xl tracking-wide
          px-8 py-4 md:px-12 md:py-5
          rounded-xl shadow-xl hover:shadow-2xl
          transform transition-all duration-300 hover:scale-105 hover:-translate-y-1
          focus:outline-none focus:ring-4 focus:ring-blue-300
          cursor-pointer overflow-hidden
          ${fullWidth ? 'w-full' : 'w-auto'}
          ${className}
        `} data-id="element-13">
        <span className="relative z-10 flex items-center gap-2" data-id="element-14">
          {children}
          <ArrowRight className="w-6 h-6 transition-transform group-hover:translate-x-1" data-id="element-15" />
        </span>
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-blue-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-16" />
      </button>;
  }
  return <a href="https://checkout.kitspremium.online/checkouts/cn/hWN81PN5tDmZUSxM6PtIJcxu/es-ar?_r=AQABi2NGslsxSM9K1DQh-oqjkrcPYJgZUp2o8gsDNeNO-jc" className={`
        group relative inline-flex items-center justify-center
        bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400
        text-white font-bold text-xl tracking-wide
        px-8 py-4 md:px-12 md:py-5
        rounded-xl shadow-xl hover:shadow-2xl
        transform transition-all duration-300 hover:scale-105 hover:-translate-y-1
        focus:outline-none focus:ring-4 focus:ring-blue-300
        cursor-pointer overflow-hidden
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} data-id="element-17">
      <span className="relative z-10 flex items-center gap-2" data-id="element-18">
        {children}
        <ArrowRight className="w-6 h-6 transition-transform group-hover:translate-x-1" data-id="element-19" />
      </span>
      <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-blue-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-20" />
    </a>;
}